export default "__VITE_ASSET__KY_1s9FI__"